module.exports = "https://coursera_assets.s3.amazonaws.com/images/5dd9cb05e2c04409ddfe0d98f50803a0.png";